"use client";
import React from "react";
import _styles from "./css/classes.module.css";
import * as _utils from "./webflow_modules/utils";
import Block from "./webflow_modules/Basic/components/Block";

export function Spacer({ variant = "Main" }) {
  const _styleVariantMap = {
    Main: "",
    4: "w-variant-97ea76ed-722e-2d33-1444-53e4464a811a",
    8: "w-variant-d27a771c-6ea3-3d5b-4248-85360c24ade4",
    12: "w-variant-e650646f-9db2-5693-318a-cda79f5e2027",
    16: "w-variant-ba3496eb-d79b-4ce7-dc74-7246875c5e3f",
    20: "w-variant-d2d4bc36-17f9-d080-d177-a19b22f17eaf",
    24: "w-variant-3d9c6ba1-8bef-69be-5dbc-37f00fbe2561",
    28: "w-variant-9a98cf57-898b-9959-ac0a-b0f3d65a47a1",
    32: "w-variant-78e8dfe0-588e-6b02-36fc-2add87346e05",
    36: "w-variant-ad5b3038-b75e-cb32-3161-15932b1ee805",
    40: "w-variant-05cf5f80-0378-48e9-07ec-f9f412885f87",
    48: "w-variant-2ebfc666-98ae-0bdc-3ff3-53cad7a6c67e",
    64: "w-variant-d047df7a-d73c-0515-e58a-be73e905aa2a",
    80: "w-variant-07878aed-4e26-79c8-88ca-32eae2bb96f9",
    112: "w-variant-50fca753-f102-9cbd-2d36-34bf149a2d02",
    160: "w-variant-39b7b614-e86e-79d2-4911-8fec0d49d00c",
    224: "w-variant-54423168-1ef5-49c6-3710-1fb8df43f8a3",
    None: "w-variant-1b747f1a-2bcc-2518-3de6-b0a6bc5979a8",
  };

  const _activeStyleVariant = _styleVariantMap[variant];

  return (
    <Block
      className={_utils.cx(_styles, "section_spacer", _activeStyleVariant)}
      id={_utils.cx(
        _styles,
        "w-node-e667cb03-80de-4b7c-2d60-b26cb415d1d4-b415d1d4"
      )}
      tag={"div"}
    />
  );
}
